(function() {
  $(function() {
    $(".afterpay-dialog-tooltip .tooltip-body").html($('#tooltip-price').html());
    $(".afterpay_button").mouseenter(function(e) {
      return $(".afterpay-dialog-tooltip").addClass("active");
    });
    $(".afterpay_button").mouseleave(function(e) {
      return $(".afterpay-dialog-tooltip").removeClass("active");
    });
    return $(".afterpay_button").mousemove(function(e) {
      var target_pos, tt, tt_height, tt_width;
      target_pos = $(e.target).offset();
      tt = $(".afterpay-dialog-tooltip");
      tt_width = tt.width();
      tt_height = 70;
      var leftPos=e.pageX - Math.round(tt_width / 2);
      if($( document ).width()<=600)
      {
        leftPos=target_pos.left+78-Math.round(tt_width / 2);
      }
      if($( document ).width()<=400)
      {
        leftPos=target_pos.left+68-Math.round(tt_width / 2);
      }
      return tt.css({
        left: leftPos,
        top: target_pos.top + tt_height
      });
    });
  });

}).call(this);

(function() {
  $(function() {
    $(".zip_button").mouseenter(function(e) {
      return $(".zip-dialog-tooltip").addClass("active");
    });
    $(".zip_button").mouseleave(function(e) {
      return $(".zip-dialog-tooltip").removeClass("active");
    });
    return $(".zip_button").mousemove(function(e) {
      var target_pos, tt, tt_height, tt_width;
      target_pos = $(e.target).offset();
      tt = $(".zip-dialog-tooltip");
      tt_width = tt.width();
      tt_height = 70;
      var leftPos=e.pageX - Math.round(tt_width / 2);
      if($( document ).width()<=600)
      {
        leftPos=target_pos.left+78-Math.round(tt_width / 2);
      }
      if($( document ).width()<=400)
      {
        leftPos=target_pos.left+68-Math.round(tt_width / 2);
      }
      return tt.css({
        left:leftPos,
        top: target_pos.top + tt_height
      });
    });
  });

}).call(this);



